import type { DeliveryPointItem } from '@/entities/order/types/delivery'

import { Drawer } from '@/shared/ui/Drawer-ios'

import { DeliveryPointInfo } from '../../api/pvz-api'
import { ShopCard } from '../shops-card/shop-card'

import cls from './drawer-shop-card.module.scss'

type DrawerShopCardProps = {
	open: boolean
	point: DeliveryPointItem
	onClose: () => void
	deliveryInfo: DeliveryPointInfo
}

export const DrawerShopCard = (props: DrawerShopCardProps) => {
	const { open, onClose, point, deliveryInfo } = props

	return (
		<Drawer contentClassName={cls.drawerContent} open={open} onClose={onClose}>
			{point && (
				<ShopCard
					metro={point.METRO_LINE}
					address={point.ADDRESS}
					postamat={point.POSTAMAT}
					storagePeriod={point.STORAGE_PERIOD}
					workShedule={point.WORK_SHEDULE}
					partner={point.DELIVERY_PVZ_PARTNER}
					description={point.DESCRIPTION}
					deliveryPrice={deliveryInfo?.DELIVERY_PRICE}
					deliveryDate={deliveryInfo?.DELIVERY_DATE}
				/>
			)}
		</Drawer>
	)
}
